/*
 * @link https://sprout.barrelstrengthdesign.com
 * @copyright Copyright (c) Barrel Strength Design LLC
 * @license https://craftcms.github.io/license
 */

// Manage the form submission process
class SproutFormsSubmitHandler {

  constructor(formId) {
    this.formId = formId;
    this.form = document.getElementById(this.formId);
    this.submitButtons = this.form.querySelectorAll('[type="submit"]');

    console.log('handle');
    this.addFormEventListener();
  }

  // Prepare the form submit button to use the Sprout Forms submit handler
  addFormEventListener() {
    let self = this;
    self.form.addEventListener('submit', function(event) {
      let targetForm = event.target;
      if (targetForm) {
        event.preventDefault();
        self.handleSubmitLogic();
      }
    }, false);

    self.form.addEventListener('beforeSproutFormsSubmit', function(event) {
      console.log('EVENT BEFORE THING')
    }, false);
  }

  /**
   * Before Submit Event
   * Submit as normal request OR submit as AJAX request (new setting?)
   * After Submit Event
   * Redirect
   */
  handleSubmitLogic() {
    let self = this;
    // Global object ?
    // window.sproutFormsSubmitBehavior = true;
    let customEventInit = {
      detail: {
        formId: self.formId,
        form: self.form
      },
      // Use event.preventDefault() to cancel
      cancelable: true
    };

    // console.log('before ca');
    // // Do we need this?
    // const onSubmitCaptchaActionsEvent = new CustomEvent('onSubmitCaptchaActionsEvent', customEventInit);
    // if (!document.dispatchEvent(onSubmitCaptchaActionsEvent)) {
    //   return;
    // }

    console.log('before submit start');
    // Do something after the form has been submitted
    const beforeSproutFormsSubmitEvent = new CustomEvent('beforeSproutFormsSubmit', customEventInit);
    if (!document.dispatchEvent(beforeSproutFormsSubmitEvent)) {
      return;
    }

    console.log('submit start');
    // Submit the form
    this.form.submit();

    console.log('after submit start');
    // Do something after the form has been submitted
    const afterSproutFormsSubmitEvent = new CustomEvent('afterSproutFormsSubmit', customEventInit);
    document.dispatchEvent(afterSproutFormsSubmitEvent);
  }

  // sendFormSubmitViaXhr(rules) {
  //   let self = this;
  //
  //   // Convert to Event
  //   function requestListener () {
  //     console.log( this.response );
  //   }
  //
  //   let postData = {};
  //
  //   let xhr = new XMLHttpRequest();
  //
  //   // bind our event listener to the "load" event.
  //   // "load" is fired when the response to our request is completed and without error.
  //   xhr.addEventListener( 'load', requestListener);
  //
  //   xhr.open('POST', 'sprout-forms/entries/save-entry');
  //   xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  //
  //   xhr.onload = function() {
  //     let response = JSON.parse(this.response);
  //     if (this.status === 200 && response.success === true) {
  //       // Handle Errors or redirect logic...
  //     } else {
  //       console.error('Invalid request while validating conditions');
  //     }
  //   };
  //
  //   postData[window.csrfTokenName] = this.form.querySelector('[name="' + window.csrfTokenName + '"]').value;
  //   postData['action'] = 'sprout-forms/rules/validate-condition';
  //   postData['rules'] = rules;
  //
  //   let body = Object.keys(postData).map(function(key) {
  //     return encodeURIComponent(key) + '=' + encodeURIComponent(postData[key])
  //   }).join('&');
  //
  //   xhr.send(body);
  // }
}

window.SproutFormsSubmitHandler = SproutFormsSubmitHandler;